import { render, staticRenderFns } from "./QuestionStep.vue?vue&type=template&id=0b4221e2&scoped=true&"
import script from "./QuestionStep.vue?vue&type=script&lang=js&"
export * from "./QuestionStep.vue?vue&type=script&lang=js&"
import style0 from "./QuestionStep.vue?vue&type=style&index=0&id=0b4221e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4221e2",
  null
  
)

export default component.exports